import { storyblokEditable } from "@storyblok/react";
import React, { useState, useEffect } from "react";
import Link from "next/link";

const CookieLayerLink = ({ blok }, props) => {



    const showCookieLayer = () =>{
        const showCookies = document.getElementsByTagName("cookie-layer-outer");
        showCookies.className += "show";
    }

    
  return (
    <div className="cookielayerlink-wrap" {...storyblokEditable(blok)}>
      <a onClick={showCookieLayer} className="cookielayerlink-link">
        {blok.text}
      </a>
    </div>
  );
};

export default CookieLayerLink;
